(function () {
    'use strict';
    angular.module('app')
        .controller('ServicesController', function (
            $timeout,
            ServicesTableService,
            $routeParams
        ) {
            let vm = this;

            init();

            function init() {
                $timeout(() => {
                    vm.ServicesTable = new ServicesTableService(getDefaultFilters()).tableData;
                });
            }

            function getDefaultFilters() {
                const filterKeys = Object.keys($routeParams);
                const filters = {}; 

                filterKeys.forEach(key => {
                    if ($routeParams[key]) {
                        filters[key] = $routeParams[key];
                    }
                });

                return filters;
            }
        });
})();


// WEBPACK FOOTER //
// ./js/controllers/ServicesController.js